// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__bi1_f","chainIcon":"styles_chainIcon__A_GYM"};